import FormField from "./FormField";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

const style = "w-full py-2 px-2 text-right";
const PATTERN = /^-?\d*\.?\d{0,6}$/;

/**
 *
 * @param {*} props -
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} label -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component TextField
 */
function Integer(props) {
  const {
    name,
    data,
    label,
    readOnly,
    placeholder,
    onChange,
    required,
    colSpan,
    model,
  } = props;
  let _style = style;
  let _color = "bg-white";
  if (readOnly) {
    _color = colors.readOnly;
  }

  function handleChange(event) {
    let _value = event.target.value;
    _value = _value.replaceAll(",", "");
    const validNumber = PATTERN.test(_value);

    if (!validNumber) {
      return;
    }
    data.value = _value;
  }

  function onBlur() {
    if (onChange) {
      onChange(name, data.value);
    }
  }

  return (
    <FormField
      label={label}
      name={name}
      required={required}
      colspan={colSpan}
      model={model}
    >
      <input
        key={name}
        id={name}
        name={name}
        className={cn(
          _color,
          _style,
          theme.textColor,
          theme.border,
          theme.input.height,
          theme.input.text,
        )}
        type="text"
        value={data.value || ""}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={readOnly ?? false}
        placeholder={placeholder ?? ""}
      />
    </FormField>
  );
}

export default Integer;
